import React from "react";
import BreadCrumbs from "../../Components/BreadCrumbs/BreadCrumbs";
import SectionHeader from "../../Components/SectionHeader/SectionHeader";
import Textinput from "../../Components/SiteComponants/FormElements/Textinput";
import InputDescription from "../../Components/SiteComponants/FormElements/InputDescription";
import SpecialButton from "../../Components/SiteComponants/SpecialButton";
import { useState } from "react";
import { useEffect } from "react";
import { faqItems } from "../../Datas/SiteData/AllinOne";
import { TitleSetup } from "../../Datas/Functions/titleSetup";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useSiteData } from "../../Contexts/SiteContext";
import { notify } from "../../Datas/Functions/toast";

const ManageFaq = (meta) => {
  TitleSetup({ ...meta });
  const [faqList, setFaqlist] = useState([]);
  const [answer, setAnswer] = useState("");
  const [selectedFaq, setSelectedFaq] = useState();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
  } = useForm();
  useEffect(() => {
    setFaqlist(faqItems);
  }, []);
  const { setIsLoading } = useSiteData();
  const onSubmit = (data) => {
    setIsLoading(true);

    console.log(data);
    setIsLoading(false);
    notify("Success", "Data Successfully Updated", "success");
    reset();
  };
  const deleteBanner = (i) => {};
  useEffect(() => {
    if (selectedFaq) {
      reset(selectedFaq);
      setAnswer(selectedFaq.answer);
    }
  }, [selectedFaq]);
  return (
    <div className="container">
      <SectionHeader heading={"FAQ Management"} className={"text-center"} />
      <BreadCrumbs texts={["Dashboard", "Manage FAQ"]} />
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 my-10 ">
        <div className="col-span-1 md:col-span-2">
          <div className="box p-5">
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <Textinput
                title={"Question"}
                name={"question"}
                type="text"
                placeholder="Enter Question"
                errors={errors}
                className={`border rounded w-full py-2 px-4 ${
                  errors.title ? "border-red-500" : "border-orange-300"
                }`}
                register={register("question", {
                  required: "Question is required",
                })}
              />
              <InputDescription
                title={"Notice Board"}
                value={answer}
                setValue={setAnswer}
                className={`border  placeholder:dark:text-white w-full`}
                placeholder="Write Answer . . . "
              />
              <Textinput
                title={"Category"}
                name={"category"}
                type="text"
                placeholder="Enter Category"
                errors={errors}
                datalist={[...new Set(faqList?.map((faq) => faq.category))]}
                className={`border rounded w-full py-2 px-4 ${
                  errors.title ? "border-red-500" : "border-orange-300"
                }`}
                register={register("category", {
                  required: "Category must be selected",
                })}
              />
              <div className="text-center my-3">
                <SpecialButton text="Submit" />
              </div>
            </form>
          </div>
        </div>
        <div className="md:col-span-3 col-span-1">
          <div className="box w-full max-h-screen overflow-scroll dark:dark-bg-front bg-front">
            <h2 className="font-bold text-xl text-center my-3">Preview </h2>
            <table className=" w-full overflow-x-scroll table">
              <thead>
                <tr>
                  <th className="p-3 font-bold uppercase bg-back dark:dark-bg-back   dark:dark-text border border-gray-300 ">
                    Question
                  </th>
                  <th className="p-3 font-bold uppercase  bg-back dark:dark-bg-back  dark:dark-text border border-gray-300 ">
                    Answer
                  </th>
                  <th className="p-3 font-bold uppercase  bg-back dark:dark-bg-back    dark:dark-text border border-gray-300 ">
                    Category
                  </th>
                  <th className="p-3 font-bold uppercase  bg-back dark:dark-bg-back    dark:dark-text border border-gray-300 ">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {faqList.length > 0 ? (
                  faqList.map((item, i) => (
                    <tr
                      key={i}
                      className="cursor-pointer text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800  duration-200"
                    >
                      <td className="w-auto p-3   border border-b   ">
                        {item.question}
                      </td>
                      <td className="w-auto p-3   border border-b text-center   ">
                        <Link to={"/faq"}>
                          <span className="text-brand underline">
                            View Answer
                          </span>
                        </Link>
                      </td>
                      <td className="w-auto p-3   border border-b text-center    ">
                        {item.category}
                      </td>
                      <td className="w-auto p-3   border border-b text-center    ">
                        <button
                          className="pr-3"
                          onClick={() => setSelectedFaq(item)}
                        >
                          <i className="fas fa-edit    "></i>
                        </button>
                        <button
                          className="pl-3"
                          onClick={() => deleteBanner(i)}
                        >
                          <i
                            className="fa fa-trash text-red-600"
                            aria-hidden="true"
                          ></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={"100%"}>
                      <h1 className="text-3xl text-center">
                        No FAQ Data Available
                      </h1>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageFaq;
